<template>
    <v-container fluid fill-height>
        <v-layout>
            <LoginForm/>
        </v-layout>
    </v-container>
</template>

<script>
    import LoginForm from "../../components/security/LoginForm";

    export default {
        name: "Login",
        components: {LoginForm}
    };
</script>

<style scoped lang="scss">
</style>
